






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Chapter extends Vue {
  @Prop({ required: true }) readonly index!: number;

  public releaseScroll() {
    this.$emit('releaseScroll');
  }

  public lockScroll() {
    this.$emit('lockScroll');
  }

  public goToNextChapter() {
    this.$emit('next');
  }

  public chapterActivated() {}

  public chapterDeactivated() {}

  get isChapterActive(): boolean {
    return this.$root.$data.activeSection === this.index;
  }

  get inTransition(): boolean {
    return this.$root.$data.inTransition;
  }

  @Watch('isChapterActive', {
    immediate: false
  })
  watchActive() {
    if (this.isChapterActive) {
      this.chapterActivated();
    } else {
      this.chapterDeactivated();
    }
  }
}
